import {TagSummaryModel} from './tagSummary.model';
import {LovValueSummary} from "../../../lov/lov-value/api/model/lovValueSummary.model";

export class TagModel {
    summary: TagSummaryModel;
    entityType: LovValueSummary;
}
